/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlChecklistV2Progress
 */
export interface ControlChecklistV2Progress {
    /**
     * 
     * @type {number}
     * @memberof ControlChecklistV2Progress
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof ControlChecklistV2Progress
     */
    done: number;
}

/**
 * Check if a given object implements the ControlChecklistV2Progress interface.
 */
export function instanceOfControlChecklistV2Progress(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "done" in value;

    return isInstance;
}

export function ControlChecklistV2ProgressFromJSON(json: any): ControlChecklistV2Progress {
    return ControlChecklistV2ProgressFromJSONTyped(json, false);
}

export function ControlChecklistV2ProgressFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlChecklistV2Progress {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': json['total'],
        'done': json['done'],
    };
}

export function ControlChecklistV2ProgressToJSON(value?: ControlChecklistV2Progress | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'done': value.done,
    };
}

